import { render, staticRenderFns } from "./FooterLPCreate.vue?vue&type=template&id=a1b39e06&"
import script from "./FooterLPCreate.vue?vue&type=script&lang=js&"
export * from "./FooterLPCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports